import { render, staticRenderFns } from "./SidebarNavDivider.vue?vue&type=template&id=639a540c&"
import script from "./SidebarNavDivider.vue?vue&type=script&lang=js&"
export * from "./SidebarNavDivider.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavDivider.vue?vue&type=style&index=0&id=639a540c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports